// @ts-ignore
import { ribbon } from '@fabric-ds/component-classes';
// @ts-ignore
import type { BapAd } from '@finn-no/search-frontend-clients/quest';
import React from 'react';
// @ts-ignore
import { IconTorgetShipping24 as IconTorgetShipping } from '@fabric-ds/icons/react';

type ShippableRibbonProps = {
    ad: BapAd;
    className?: string;
    ribbonClass?: string;
};

function ShippableRibbon(props: ShippableRibbonProps) {
    const { ad, className } = props;

    const shippingExists = ad.flags?.includes('shipping_exists');

    const ribbonClass = `${ribbon.base
        } mb-8 rounded-bl-0 rounded-tr-0 text-12 text-yellow-800 border-bluegray-300 ${props.ribbonClass || ''
        }`;
    const ribbonStyle = {
        borderWidth: '1px 0 0 1px',
        borderTopLeftRadius: '8px',
    };

    return shippingExists ? (
        <div className={className}>
            <span className={`${ribbonClass} ${ribbon.warning}`} style={ribbonStyle}>
                <IconTorgetShipping className="w-16 h-16 mr-4" />
                Fiks ferdig
            </span>
        </div>
    ) : null;
}

export default ShippableRibbon;
